module.exports = __webpack_public_path__ + "img/595-42dfb3.png";